import React from "react";
import Intro from "./components/Intro";
import BasedOnAsset from "./components/BasedOnAsset";
import BasedOnObjective from "./components/BasedOnObjective";
import BasedOnRiskFactor from "./components/BasedOnRisk";
import BasedOnStructure from "./components/BasedOnStructure";
import SpecialisedMf from "./components/SpecialisedMf";
import FAQs from "./components/QnA";
import Layout from "../../components/Layout/Layout";
import style from "./mfseo.module.css";
import SEO from "../../components/SEO/SEO";

const MutualFundSEOPage = () => (
  <Layout>
    <SEO link="/mutual-funds/" />
    <div className={style.container}>
      <Intro />
      <BasedOnAsset />
      <BasedOnObjective />
      <BasedOnRiskFactor />
      <BasedOnStructure />
      <SpecialisedMf />
      <FAQs />
    </div>
  </Layout>
);
export default MutualFundSEOPage;
